import React from "react";
import { Box, useTheme } from "@material-ui/core";
import { ErrorIcon, SuccessIcon, InfoIcon } from "../../../icons";

export type ValidityTypes = {
  isValid: boolean;
  isError: boolean;
  isWarning: boolean;
};
export const ValidityIcon: React.FC<ValidityTypes> = ({
  isValid,
  isError,
  isWarning,
}) => {
  const theme = useTheme();

  return (
    <Box lineHeight={1} ml={1} alignSelf="center" data-testid="ValidityIcon">
      {isError ? (
        <ErrorIcon
          width={22}
          height={22}
          style={{ fill: theme.palette.error.main }}
        />
      ) : isWarning ? (
        <InfoIcon
          width={22}
          height={22}
          style={{ fill: theme.palette.secondary.main }}
        />
      ) : isValid ? (
        <SuccessIcon
          width={22}
          height={22}
          style={{ fill: theme.palette.success.main }}
        />
      ) : null}
    </Box>
  );
};
